<div #modal class="ngumodal" [class.in]="openModals">
  <div class="main">
    <div class="innerdiv">
      <div #modalInner class="innerMain" [@viewAnimation] *ngIf="isOpened">
        <ng-content></ng-content>
      </div>
    </div>
    <div class="overlay" [@fadeAnimation] *ngIf="isOpened" (click)="this.MIndex.backdrop && close()"></div>
  </div>
</div>
